import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import StarField from "../components/StarField";
import Footer from "../components/Footer";
import { api, setSeo, readCache, writeCache } from "../lib/api";

export default function OldResults() {
  const [history, setHistory] = useState(() => readCache("sle_history") || { time_slots: [], rows: [] });
  const { time_slots: timeSlots, rows } = history;
  const navigate = useNavigate();

  useEffect(() => {
    setSeo(
      "All Old Results - Shillong Lucky Ending Chart | Lucky Lottery History",
      "Browse the complete Shillong Lucky Ending old results chart. View the last 7 days of Lucky Ending lucky lottery numbers across every 15-minute slot from 09:00 AM to 08:00 PM."
    );
    api
      .get("/results/history")
      .then(({ data }) => {
        setHistory(data);
        writeCache("sle_history", data);
      })
      .catch(() => {});
  }, []);

  return (
    <div data-testid="old-results-page">
      <StarField />
      <Header />

      <div className="page-header">
        <h1>All Old Results</h1>
        <button className="btn-home" onClick={() => navigate("/")} data-testid="back-home-btn">
          Back to Home
        </button>
      </div>

      <div className="table-wrapper" data-testid="results-table-wrapper">
        <table className="result-table">
          <thead>
            <tr>
              <th>Date</th>
              {timeSlots.map((t) => (
                <th key={t}>{t}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.date} data-testid={`row-${row.date}`}>
                <td className="date-col">{row.date}</td>
                {row.cells.map((c, i) => (
                  <td key={i}>{c === null || c === undefined ? "" : c}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="content-area">
        <div className="content-inner">
          <h2>Comprehensive Guide to Shillong Lucky Ending Old Results</h2>
          <p>
            Welcome to our dedicated archive page for the <strong>Shillong Lucky Ending</strong> results. If you are a
            regular follower or a passionate participant in the traditional archery games of Meghalaya, you understand
            that tracking past performance is not just a habit — it is an essential strategy. On this page we provide a
            meticulously organised, real-time updated and fully transparent table showcasing the historical data of the
            ending digits. From the crack of dawn at 09:00 AM to the closing sessions at 08:00 PM, every single
            fifteen-minute slot is documented here for your analytical convenience.
          </p>
          <p>
            The game of Shillong Teer is a beautiful amalgamation of cultural heritage and mathematical probability.
            While the thrill of the live arrow count is unmatched, the post-game analysis holds the key for future
            predictions. By studying our old results chart you gain access to a treasure trove of data that reveals
            patterns, recurring sequences and the overall rhythm of this famous <strong>lucky lottery</strong> over the
            past few days.
          </p>

          <h2>Why Analysing Previous Results is Crucial</h2>
          <ul>
            <li>
              <strong>Identifying Hot and Cold Numbers:</strong> A quick glance at the horizontal rows and vertical
              columns helps you spot which digits are hitting frequently and which ones have been absent for days.
            </li>
            <li>
              <strong>Verifying Authenticity:</strong> An archived record ensures maximum transparency, so you can
              cross-check our data with official association announcements.
            </li>
            <li>
              <strong>Building Mathematical Logic:</strong> Access to a continuous week of data lets enthusiasts apply
              their own formulas rather than relying purely on random guessing.
            </li>
          </ul>

          <h2>How Our Automated Table Works</h2>
          <p>
            The table above is not manually typed out — it is a <strong>dynamic, database-driven system</strong>. The
            oldest date in the current seven-day cycle is pinned at the top, and as you scroll down you travel forward
            in time, with today's latest date resting at the very bottom. When a new day begins the system
            automatically drops the oldest date and adds the fresh one, ensuring you always enjoy a rolling seven-day
            perspective of the <strong>Lucky Ending</strong> history.
          </p>

          <h2>Safe Play and Responsible Engagement</h2>
          <p>
            While analysing the Shillong Lucky Ending digits is deeply entertaining and mathematically engaging, we
            must emphasise the importance of responsible behaviour. The data provided here is strictly for
            informational and analytical purposes. We do not guarantee future outcomes based on past records, and there
            is no secret trick to <strong>pay gold win</strong> in any game of chance. Please remember that engagement
            in any real-world activity related to this sport should only be done by individuals who are{" "}
            <strong>18 years of age or older</strong>.
          </p>

          <h3>Frequently Asked Questions (FAQs)</h3>
          <p>
            <strong>Q: Why does the table only show the last 7 days?</strong>
            <br />
            A: To maintain optimum website speed and provide the most relevant, recent data, we restrict the live table
            to a rolling seven-day window — the sweet spot for pattern analysis.
          </p>
          <p>
            <strong>Q: How do I read the table on a mobile phone?</strong>
            <br />
            A: Simply swipe left or right on the table to view later time slots. The Date column stays locked in place
            so you never lose track of which day you are analysing.
          </p>
          <p>
            Thank you for choosing our platform as your trusted source. Bookmark this page and check back daily to stay
            ahead with the most accurate Shillong Lucky Ending archives available online! Return to the{" "}
            <Link className="inlink" to="/">live result</Link>, learn more <Link className="inlink" to="/about">about
            the game and prize structure</Link>, or read our <Link className="inlink" to="/terms">Terms &amp;
            Conditions</Link>.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
